import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormFeedback,
  Alert,
  Spinner,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import ParticlesAuth from "../../AuthenticationInner/ParticlesAuth";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
// import { resetLoginFlag } from "../../../slices/thunks";
import { createSelector } from "reselect";
import { getLoggedInUser } from "../../../helpers/fakebackend_helper";
// import rectangle from "../../assets/images/Rectangle 23.png";
// import logo from "../../assets/images/Group 1.png";
import toast from "react-hot-toast";

// import Register from "./Register";
import { login } from "../../../slices/qaManagment/authentication/thunk";
import { setLoginModalOpen, setRegisterModalOpen } from "../../../slices/modal/modalSlice";

const Login = ({ isOpen, toggle, onSuccess }) => {
  const authuser = getLoggedInUser();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [verifyModalOpen, setVerifyModalOpen] = useState(false); // State for verification modal

  const toggleVerifyModal = () => setVerifyModalOpen(!verifyModalOpen);

  const loginpageData = createSelector(
    (state) => state,
    (state) => ({
      user: state.Account.user,
      error: state.Login.error,
      loading: state.Login.loading,
      errorMsg: state.Login.errorMsg,
    })
  );

  const { error, loading, errorMsg } = useSelector(loginpageData);
  const [passwordShow, setPasswordShow] = useState(false);

  const modalData = createSelector(
    (state) => state,
    (state) => ({
      loginModalOpen: state.modal.loginModalOpen,
      registerModalOpen: state.modal.registerModalOpen,
    })
  );
  const { loginModalOpen, registerModalOpen } = useSelector(modalData);

  console.log("loginjs registermodalopen", registerModalOpen);
  console.log("loginjs loginmodalopen", loginModalOpen);

  const registerToggleModal = () => {
    dispatch(setRegisterModalOpen(!registerModalOpen));
    dispatch(setLoginModalOpen(false));
  };
  const validation = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),

    onSubmit: async (values) => {
      const result = await dispatch(login(values, navigate, toggleVerifyModal));
      console.log("reult", result);
      if (!result.error) {
        onSuccess();
        toggle();
      }

      // dispatch(login(values, navigate)).then(() => {
      //   if (!error) {
      //     onSuccess();
      //     toggle();
      //   }
      // });
    },
  });

  useEffect(() => {
    if (errorMsg) {
      toast.error(errorMsg);
    }
  }, [errorMsg]);

  document.title = "Cosmos Driving | Customer Panel";

  return (
    <ParticlesAuth>
      <Modal
        isOpen={loginModalOpen}
        toggle={toggle}
        className="modal-fullscreen"
      >
        <ModalHeader
          toggle={toggle}
          className="container"
          style={{ height: "90px" }}
        >
          <Link to="/" className="d-flex justify-content-end align-items-end">
            {/* <img
              src={logo}
              className="img-fluid"
              alt="Cosmos Logo"
              style={{ height: "auto", width: "auto" }}
            /> */}
          </Link>
        </ModalHeader>

        <ModalBody>
          <Container>
            <Row className="justify-content-center align-items-center">
              <Col
                lg={{ size: 5, order: 1 }}
                xs={{ size: 12, order: 2 }}
                className="position-relative mb-4 mb-lg-0 d-flex align-items-center"
              >
                {/* <img
                  src={rectangle}
                  style={{
                    width: "100%",
                    height: "auto",
                    objectFit: "cover",
                    borderRadius: "15px",
                  }}
                  alt="Background"
                /> */}
                <div
                  style={{
                    position: "absolute",
                    bottom: "0px",
                    borderRadius: "15px",
                    backgroundColor: "rgba(0, 0, 0, 0.63)",
                    color: "#fff",
                    zIndex: "1",
                    width: "95%",
                    height: "auto",
                    padding: "20px",
                  }}
                >
                  <h2 className="fw-800 text-white">
                    <i className="bx bxs-quote-alt-left"></i>
                  </h2>
                  <p className="text-white fs-14 fw-400">
                    Thanks Bishnu(Cosmos driving), I obtained my full driving
                    licence with the support of Cosmos driving school. The
                    experience was exceptional with outstanding teaching. Very
                    professional and guided me to pass the driving test with
                    confidence in the first attempt. Highly recommended!
                  </p>
                  <div className="d-flex justify-content-between">
                    <h6 className="text-white">Suharshi Perera</h6>
                    <div className="d-flex">
                      <i className="bx bxs-star"></i>
                      <i className="bx bxs-star"></i>
                      <i className="bx bxs-star"></i>
                      <i className="bx bxs-star"></i>
                      <i className="bx bxs-star"></i>
                    </div>
                  </div>
                </div>
              </Col>
              <Col
                lg={{ size: 1, order: 1 }}
                xs={{ size: 12, order: 2 }}
                className="d-flex align-items-center"
              ></Col>
              <Col
                lg={{ size: 6, order: 2 }}
                xs={{ size: 12, order: 1 }}
                className="d-flex align-items-center justify-content-center"
              >
                <div className="center w-100">
                  <div className="text-start">
                    <h5 className="fw-bold">Login</h5>
                    <p className="text-muted">
                      Login to access your Cosmos account
                    </p>
                  </div>
                  {errorMsg && <Alert color="danger">{errorMsg}</Alert>}
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="form-floating mb-3">
                      <Input
                        name="email"
                        className="form-control"
                        placeholder="Enter Email"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          !!(
                            validation.touched.email && validation.errors.email
                          )
                        }
                        style={{
                          padding: "0.5rem",
                          height: "1rem",
                        }}
                      />
                      <Label for="email">Email address</Label>
                      {validation.touched.email && validation.errors.email && (
                        <FormFeedback>{validation.errors.email}</FormFeedback>
                      )}
                    </div>

                    <div className="form-floating mb-3">
                      <Input
                        name="password"
                        value={validation.values.password || ""}
                        type={passwordShow ? "text" : "password"}
                        className="form-control pe-5"
                        placeholder="Enter Password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          !!(
                            validation.touched.password &&
                            validation.errors.password
                          )
                        }
                        style={{
                          padding: "0.5rem",
                          height: "1rem",
                        }}
                      />
                      <Label for="password">Password</Label>
                      {validation.touched.password &&
                        validation.errors.password && (
                          <FormFeedback>
                            {validation.errors.password}
                          </FormFeedback>
                        )}
                      <button
                        className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted mt-2"
                        type="button"
                        onClick={() => setPasswordShow(!passwordShow)}
                        style={{
                          marginRight:
                            validation.touched.password &&
                            validation.errors.password
                              ? "18px"
                              : "0px",
                        }}
                      >
                        {passwordShow ? (
                          <i
                            className="bx bxs-show"
                            style={{ fontSize: "22px" }}
                          ></i>
                        ) : (
                          <i
                            className="bx bxs-hide"
                            style={{ fontSize: "22px" }}
                          ></i>
                        )}
                      </button>
                    </div>

                    <div className="form-check">
                      <Input
                        className="form-check-input"
                        type="checkbox"
                        id="auth-remember-check"
                      />
                      <Label
                        className="form-check-label"
                        htmlFor="auth-remember-check"
                      >
                        Remember me
                      </Label>
                      <div className="float-end">
                        <Link to="/forgot-password" className="link">
                          Forgot password?
                        </Link>
                      </div>
                    </div>

                    <div className="mt-4">
                      <Button
                        disabled={loading}
                        className="w-100"
                        type="submit"
                        style={{ backgroundColor: "#FE7D29", border: "none" }}
                      >
                        {loading && (
                          <Spinner size="sm" className="me-2">
                            Loading...
                          </Spinner>
                        )}
                        Login
                      </Button>
                    </div>
                    <div className="mt-2 mb-5 text-center">
                      <h6>
                        Don't have an account?{" "}
                        <span
                          onClick={registerToggleModal}
                          className="link cursor-pointer"
                        >
                          Sign Up
                        </span>
                      </h6>
                    </div>
                  </Form>
                </div>
              </Col>
            </Row>
          </Container>
        </ModalBody>
        <Container className="">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center text-center text-md-start py-3">
            <p className="mb-0">
              Copyright &copy; {new Date().getFullYear()} Cosmos Driving
            </p>
            <p className="mb-0">
              Design and developed by{" "}
              <Link to="#" className="link">
                Avoca Digital
              </Link>
            </p>
          </div>
        </Container>
        <Register
          isOpen={registerModalOpen}
          toggle={registerToggleModal}
          onSuccess={() => {
            setRegisterModalOpen(false);
            dispatch(setRegisterModalOpen(false));
          }}
        />
      </Modal>
      <Verify
        isOpen={verifyModalOpen}
        toggle={toggleVerifyModal}
        onSuccess={() => {
          // setUser(true); // Set user state to indicate successful login
          setVerifyModalOpen(false); // Close the modal
        }}
      />
    </ParticlesAuth>
  );
};

export default Login;
